/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import moment from 'moment'

type props = {
  activity_Description: string
  created_Date: string
  user: string
}
 
const ActivityDrawerItem: FC<props> = (props) => {
  return ( 
    <div className='timeline-item'>
      <div className='timeline-line w-40px'></div>

      <div className='timeline-icon symbol symbol-circle symbol-40px me-4'>
        <div className='symbol-label bg-light'>
          <KTSVG
            path='/media/icons/duotune/communication/com003.svg'
            className='svg-icon-2 svg-icon-gray-500'
          />
        </div>
      </div>

      <div className='timeline-content mb-10 mt-n1'>
        <div className='pe-3 mb-5'>
          <div className='fs-5 fw-bold mb-2'>{props.activity_Description}</div>
          <div className='d-flex align-items-center mt-1 fs-6 me-2'>
            {props.user && (
              <div className='symbol symbol-circle symbol-25px'>
                <div className='symbol-label fs-8 fw-bold bg-primary text-inverse-primary'>
                  {props.user[0]}
                </div>
              </div>
            )}

            <div className='text-muted ms-2 fs-7'>
              tarafından {moment(new Date(props.created_Date)).format('DD-MM-yyyy HH:mm')} tarihinde
              yapılan işlem.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ActivityDrawerItem}
